import React, { FC, useEffect, } from 'react';

import { CacheUtil } from '../util/CacheUtil';
import Loading from '@/components/Loading';
import router from 'next/router';
import storage from 'good-storage';

/**
 * '/'にアクセスされるときに、ログイン済みなら、/homeに遷移し、ログインしていないなら、/login　に遷移させる
 */
const LoginCheck: FC = () => {
    const localStorageInfo = storage.get('HAPLoginInfo') || '{}';

    useEffect(() => {
        const currentPath = storage.session.get('currentPath');
        const currentHref = storage.session.get('currentHref');
        // Guard: if currentPath is '/' or empty, fall back to /home to prevent
        // an infinite redirect loop (index.tsx → '/' → index.tsx → ...).
        const hasValidPath = currentPath && currentPath !== '/';
        localStorageInfo.user_name
            ? hasValidPath
                ? router.push(currentHref || currentPath)
                : router.push({ pathname: '/home' })
            : (CacheUtil.clearLoginInfo,
                router.push({ pathname: '/samlLogin' }));
    }, [localStorageInfo, storage.session]);

    return (
        <div className="flex flex-wrap items-center w-full justify-center mt-40">
            <Loading />
        </div>
    );
};

export default LoginCheck;
